var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Treeremoval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iLWKHwRaXPmZ6xoi7hcxFa",
    x1: 16.045,
    x2: 16.045,
    y1: 44.033,
    y2: 33.46,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 8",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iLWKHwRaXPmZ6xoi7hcxFb",
    x1: 6.779,
    x2: 25.903,
    y1: -4.46,
    y2: 48.08,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 101",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iLWKHwRaXPmZ6xoi7hcxFc",
    x1: 30,
    x2: 30,
    y1: 1277.682,
    y2: 1271.189,
    gradientTransform: "translate(0 -1234)",
    xlinkHref: "#iLWKHwRaXPmZ6xoi7hcxFa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iLWKHwRaXPmZ6xoi7hcxFd",
    x1: 15.076,
    x2: 35.154,
    y1: -5.766,
    y2: 49.397,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 112",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33c481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21a366"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iLWKHwRaXPmZ6xoi7hcxFa)",
    d: "M13.04545,15h6V43a1.00036,1.00036,0,0,1-1,1h-4a1.00036,1.00036,0,0,1-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iLWKHwRaXPmZ6xoi7hcxFb)",
    d: "M26.10162,19.09027A6.49961,6.49961,0,0,0,21.50006,8c-.16968,0-.33618.01263-.50256.02539.00006-.00867.00256-.01672.00256-.02539a5,5,0,1,0-10,0c0,.00867.0025.01672.00256.02539C10.83624,8.01263,10.66974,8,10.50006,8A6.49961,6.49961,0,0,0,5.8985,19.09027a6.49191,6.49191,0,0,0,5.182,11.70813,4.9809,4.9809,0,0,0,9.83911,0,6.49571,6.49571,0,0,0,5.182-11.70813Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iLWKHwRaXPmZ6xoi7hcxFc)",
    d: "M27,35h6v8a1.00036,1.00036,0,0,1-1,1H28a1.00036,1.00036,0,0,1-1-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iLWKHwRaXPmZ6xoi7hcxFd)",
    d: "M44.687,34.243,39.02106,26h.225a1.74792,1.74792,0,0,0,1.465-2.703L35.884,15.88135A1.70347,1.70347,0,0,0,36.76,13.425l-5.374-9.11a1.61166,1.61166,0,0,0-2.774.001l-5.374,9.11a1.699,1.699,0,0,0,.87469,2.45667L19.285,23.301A1.74564,1.74564,0,0,0,20.75006,26h.22571l-5.66272,8.239A1.76174,1.76174,0,0,0,16.764,37H43.236A1.75941,1.75941,0,0,0,44.687,34.243Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.11,15.88a1.6856,1.6856,0,0,1-.87-2.45l2.35-3.99c-.13-.1-.27-.21-.41-.3s-.28-.18-.42-.26l-2.38,4.04a2.67971,2.67971,0,0,0-.23,2.26,2.77519,2.77519,0,0,0,.6.97L18.45,22.76a2.73093,2.73093,0,0,0,.89,3.85l-4.85,7.06A2.76006,2.76006,0,0,0,16.76,38h2.29V37H16.76a1.76458,1.76458,0,0,1-1.45-2.76L20.98,26h-.23a1.74363,1.74363,0,0,1-1.46-2.7Z",
    opacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.11,15.88a1.6856,1.6856,0,0,1-.87-2.45l2.35-3.99c-.13-.1-.27-.21-.41-.3l-2.37,4.03a2.18286,2.18286,0,0,0,.59,2.89l-4.53,6.97a2.1966,2.1966,0,0,0-.1,2.29,2.17149,2.17149,0,0,0,1.32,1.08L14.9,33.96a2.259,2.259,0,0,0,1.86,3.54h2.29V37H16.76a1.76458,1.76458,0,0,1-1.45-2.76L20.98,26h-.23a1.74363,1.74363,0,0,1-1.46-2.7Z",
    opacity: 0.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Treeremoval);
export default __webpack_public_path__ + "static/media/icons8-treeremoval.3db313c415a6e1360c8b4e4146593e0e.svg";
export { ForwardRef as ReactComponent };